import { createSlice } from '@reduxjs/toolkit';

type dateMajTabs = {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  [tabId: string]: any;
};
export const dateSlice = createSlice({
  name: 'date',
  initialState: {
    needToSave: true,
    values: {} as dateMajTabs,
  },
  reducers: {
    // refreshDate: (state, action: { payload: keyof typeof state.values }) => {
    //   const key = action.payload;
    //   state.values[key] = new Date().toISOString();
    // },
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    setDate: (state: any, action) => {
      const { tabId, sectionKey, date } = action.payload;
      if (!state.values[tabId]) {
        state.values[tabId] = {};
      }
      state.values[tabId][sectionKey] = date;
    },
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    deleteDateRefresh: (state: any, action) => {
      state.needToSave = false;
      const { tabId } = action.payload;
      const { [tabId]: _, ...restValues } = state.values;
      state.values = restValues;
    },
    savedDateRefresh: (state) => {
      state.needToSave = true;
    },
  },
  selectors: {
    selectDate: (state) => state,
    dateRefreshNeedToSave: (state) => state.needToSave,
  },
});

export const { setDate, deleteDateRefresh, savedDateRefresh } = dateSlice.actions;

// Selector to get a specific date value
export const { selectDate, dateRefreshNeedToSave } = dateSlice.selectors;

export default dateSlice.reducer;
